import { Logo } from "@p0security/frontend-core/react";
import { integrationRegistry } from "@p0security/shared/integrations/registry";

/** GitHub's mark, for links that point at GitHub (e.g. a remediation PR) */
export const GithubIcon = (
  <Logo
    logo={integrationRegistry["github-ai"].logoUrl}
    title="GitHub"
    size={20}
  />
);
